import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { CookieService } from "ngx-cookie-service";

@Injectable({
  providedIn: "root",
})
export class AdminGuard {
  constructor(public router: Router, private cookieService: CookieService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const userStr = localStorage.getItem("user");
    const token = localStorage.getItem("token");
    const cookieToken = this.cookieService.get("token");

    if (!token && !cookieToken) {
      console.log(
        "AdminGuard - Nenhum token encontrado, redirecionando para login"
      );
      this.router.navigate(["/auth/login"]);
      return false;
    }

    if (!userStr) {
      console.log(
        "AdminGuard - Nenhum usuário encontrado, redirecionando para login"
      );
      this.router.navigate(["/auth/login"]);
      return false;
    }

    try {
      const user = JSON.parse(userStr);
      if (!user || !user.token) {
        console.log(
          "AdminGuard - Usuário inválido ou sem token, redirecionando para login"
        );
        this.router.navigate(["/auth/login"]);
        return false;
      }

      console.log("AdminGuard - Usuário autenticado:", user);
      return true;
    } catch (error) {
      console.log("AdminGuard - Erro ao parsear usuário:", error);
      this.router.navigate(["/auth/login"]);
      return false;
    }
  }
}
